module.exports = __webpack_public_path__ + "static/media/meals.26bdd9cf.svg";